import type { NavLink } from '@/types'

export const NAV_LINKS: NavLink[] = [
    { href: '/', label: 'Work' },
    { href: '/about', label: 'About' },
    { href: '/contact', label: 'Contact' }
]
